<div class="rfq-lot-search-dropdown__wrapper">
  <input
    matInput
    class="w-100 lum-input"
    [placeholder]="selectedItem?.lot_number || ''"
    [formControl]="searchControl"
    [matAutocomplete]="auto"
    #searchInput
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    panelWidth="auto"
    [displayWith]="displaySelectedItem"
    [infiniteScrollFetchingData]="(loadingRfqLots$ | async) || false"
    (lumInfiniteScroll)="getRfqLots()"
    (optionSelected)="onSelectItem($event)"
    (closed)="onClosePanel()"
    (opened)="getRfqLots()"
  >
    <mat-option *ngFor="let rfqLot of rfqLots; trackBy: trackById" [value]="rfqLot">
      {{ rfqLot?.lot_number || '' }}
    </mat-option>
    <mat-option *ngIf="loadingRfqLots$ | async">
      <mat-progress-spinner
        class="progress-spinner"
        diameter="16"
        mode="indeterminate"
      ></mat-progress-spinner>
    </mat-option>
    <mat-divider></mat-divider>
    <mat-option (click)="onCreateNewLot()"> Create a New Lot </mat-option>
  </mat-autocomplete>
  <button
    *ngIf="clearable && selectedItem && !(loadingRfqLots$ | async)"
    mat-icon-button
    type="button"
    aria-label="Clear"
    class="clear-button"
    (click)="onRemoveItem()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
